import { useEffect } from 'react';
import { useLogout, useNotify, useRedirect } from 'react-admin';

const LogoutPage = () => {
    const logout = useLogout();
    const redirect = useRedirect();
    const notify = useNotify();

    useEffect(() => {
        const performLogout = async () => {
            try {
                await logout();
                notify('Logged out successfully');
                redirect('/login');
            } catch (error) {
                console.error('Logout failed', error);
                // Handle the error appropriately
            }
        };

        void performLogout();
    }, [logout, notify, redirect]);

    return null; // Or a loading spinner, message, etc.
};

export default LogoutPage;
export {};
